import http from '@/js/Http'
import {AxiosOptions} from 'guaxinim-web'

export default {
  getSessao() {
    const url = `sessao/`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  login(credencial) {
    const url = `sessao/`
    return new Promise((resolve, reject) => {
      http.post(url, credencial).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  }
}